import { useLayoutEffect, useRef } from 'react'
import type { ReactNode } from 'react'

interface ModalProps {
  open: boolean
  onClose: () => void
  title: string
  children: ReactNode
}

export function Modal({ open, onClose, title, children }: ModalProps) {
  const ref = useRef<HTMLDialogElement>(null)

  // useLayoutEffect (not useEffect) so the dialog is actually open — and
  // laid out — before paint. Children (e.g. an <img> driving a crop) can
  // otherwise measure a 0x0 box if they load before a deferred effect runs.
  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return
    if (open) el.showModal()
    else el.close()
  }, [open])

  return (
    <dialog
      ref={ref}
      onCancel={onClose}
      onClick={(e) => {
        if (e.target === ref.current) onClose()
      }}
      style={{
        position: 'fixed',
        margin: 'auto',
        border: '1px solid var(--border-soft)',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'var(--shadow-md)',
        padding: 0,
        maxWidth: 560,
        width: '90vw',
        background: 'var(--surface-card)',
      }}
    >
      <div style={{ padding: 'var(--space-6)' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 'var(--space-5)',
          }}
        >
          <h2 style={{ margin: 0, fontSize: 'var(--text-h3)' }}>{title}</h2>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: 20,
              color: 'var(--ink-2)',
              lineHeight: 1,
              padding: '4px 8px',
            }}
            aria-label="Fermer"
          >
            ×
          </button>
        </div>
        {children}
      </div>
    </dialog>
  )
}

export default Modal
